import { api } from '@/global/services/api'

export default {
  data () {
    return {
      showLoader: false
    }
  },

  methods: {
    isDownloadDisabled (event) {
      const row = event?.rowData || event?.data
      return !row?.has_output || row?.success === false
    },

    isReportUnviewed (event) {
      const row = event?.rowData || event?.data || event
      return !row?.viewed_at && row?.success === true
    },

    async exportReport (event, format) {
      const row = event?.rowData || event?.data
      if (!row?.id || this.isDownloadDisabled(event)) {
        return false
      }

      try {
        this.showLoader = true

        const response = await api('satellite-tracking').get(
          `report-generated/${row.id}/export`,
          { format },
          { responseType: 'blob' }
        )

        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        const reportName = row?.report?.name ? this.$t(row.report.name) : 'report'
        link.href = url
        link.setAttribute('download', `${reportName}.${format}`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        await this.markAsViewed(row.id)

        // Optimistically mark the row as viewed locally. The row object is shared
        // with the table data, so the unviewed indicator/highlight (and the status
        // column) clear immediately — without depending on the unviewed counter
        // changing (it may still be 0 if the count hasn't been polled yet).
        this.$set(row, 'viewed_at', new Date().toISOString())

        return true
      }
      catch (e) {
        console.error(e)
        return false
      }
      finally {
        this.showLoader = false
        this.$store.dispatch('base/config/fetchUnviewedReportsCount')
      }
    },

    async markAsViewed (id) {
      try {
        await api('satellite-tracking').put(`report-generated/${id}/viewed`)
      }
      catch (e) {
        // non-critical
      }
    }
  }
}
